<template>
  <div>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="DOT活动" name="1">
        <event-program ref="eventProgram"></event-program>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import eventProgram from '../dot/order/taskTemplate/event-program'
import {mapGetters} from "vuex";
export default {
  components: {eventProgram},
  data() {
    return {
      activeName: "1",
    }
  },
  methods: {
    handleClick(tab, event) {
        this.$refs.eventProgram.init();
    },
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  filters: {},
}

</script>
<style lang="scss" scoped>
.avue-view {
  background: #FFFFFF;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

.desc-info {
  width: 100%;
  padding-left: 0;

  > span {
    margin-right: 50px;
  }
}
</style>
